__webpack_require__.p = "/templates/customWeb2/ModulesReact/buildInformationModule/";